import { actions, types } from './requests'
export const GETBADGELIST_TYPES = {
    ...types('GETBADGELIST'),
}
export const GETBADGELIST_ACTIONS = {
    ...actions('GETBADGELIST'),
}